import { type customParmsItem} from "@rokid/store/src/parameter.ts"

export enum ItemType{
    customParms = 18
}

export interface ParameterConfig{
    param_list:Array<customParmsItem>
}